import { NgModule } from '@angular/core';
import { ListProductsComponent } from './list-products/list-products.component';
import { SharedModule } from '../shared/shared.module';
import { ProductRoutingModule } from './product.routing.module';
import { AddProductComponent } from './add-product/add-product.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ProductFormComponent } from './product-form/product-form.component';
import { EditProductFormComponent } from './edit-product/edit-product-form/edit-product-form.component';
import { ProductManagementCardComponent } from './product-management-card/product-management-card.component';
import { AddProductDialogueComponent } from './add-product/add-product-dialogue/add-product-dialogue.component';
import { AddProductFormComponent } from './add-product/add-product-form/add-product-form.component';
import { EditProductDialogueComponent } from './edit-product/edit-product-dialogue/edit-product-dialogue.component';
import { ProductDeletionDialogComponent } from './product-deletion-dialog/product-deletion-dialog.component';
import { SearchComponent } from './search/search.component';
import { StorePreviewComponent } from './product-details/store-preview/store-preview.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ProductPayloadErrorDialogComponent } from './product-payload/product-payload-error-dialog/product-payload-error-dialog.component';
import { ProductPayloadProgressComponent } from './product-payload/product-payload-progress/product-payload-progress.component';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { ProductDetailsCategoriesComponent } from './product-details/product-details-categories/product-details-categories.component';

@NgModule({
  declarations: [
    ListProductsComponent,
    AddProductComponent,
    ProductDetailsComponent,
    ProductFormComponent,
    EditProductFormComponent,
    ProductManagementCardComponent,
    AddProductDialogueComponent,
    AddProductFormComponent,
    EditProductDialogueComponent,
    ProductDeletionDialogComponent,
    SearchComponent,
    StorePreviewComponent,
    ProductPayloadErrorDialogComponent,
    ProductPayloadProgressComponent,
    ProductDetailsCategoriesComponent,
  ],
  imports: [
    ProductRoutingModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatTreeModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
  ],
  exports: [
    ListProductsComponent,
    AddProductComponent,
    ProductManagementCardComponent,
  ],
})
export class ProductModule {}
